import { Size } from "@/api/AppApi/common-interfaces/api-enums";
import { IBrand } from "@/api/AppApi/services/home/interfaces/IBrands";
import NextImage from "@/app/components/lib/NextImage";
import { Col, Row } from "@/app/components/lib/my-bootstrap";
import { truncateString } from "@/utils/functions/functions";

interface Props {
  size: Size;
  brand?: IBrand;
}

const ProductBrand: React.FC<Props> = ({ size, brand }) => {
  const maxTextLength =
    size === Size.small || size === Size.vertical_small ? 45 : 108;
  // if (!brand) return null;
  return (
    <Row className="product-brand" style={{ gap: 4 }}>
      <Col className="p-0 col-auto">
        {brand?.logo_url && (
          <NextImage
            objectFit="fill"
            src={brand?.logo_url ?? ""}
            alt="brand"
            width={18}
            height={18}
          />
        )}
      </Col>
      <Col className="p-0">
        {truncateString(brand?.name ?? "", maxTextLength)}
      </Col>
    </Row>
  );
};

export default ProductBrand;
